module.exports = __webpack_public_path__ + "03_mid_brown.3cdde9d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_mid_brown.png
// module id = ec8p
// module chunks = 0